import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Description, GroupLabel } from "../../menu-list-item/MenuListItem.styled";
import * as Styled from "./Select.styled";
export const SelectLabel = ({ groupLabel, label, labelId, description }) => (_jsxs(Styled.Label, { children: [groupLabel && _jsx(GroupLabel, { children: groupLabel }), _jsx("span", { id: labelId, children: label }), description && _jsx(Description, { children: description })] }));
